import { gql } from '@apollo/client';

export const DELETE_SESSION = gql`
  mutation deleteSession($id: ID!) {
    session: deleteSession(id: $id) {
      id
      name
    }
  }
`;
